const state = {
 reload_phones: false,
 reload_emails: false,
};
const actions = {};
const mutations = {
 RELOAD_PHONES(state, payload) {
  state.reload_phones = payload.action;
 },
 RELOAD_EMAILS(state, payload) {
  state.reload_emails = payload.action;
 }
};
export default {
 state,
 actions,
 mutations
}
